"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.qmCarOrderListApi = qmCarOrderListApi;
exports.qmCarOrderReservationListApi = qmCarOrderReservationListApi;
exports.qmCarOrderTestDetailApi = qmCarOrderTestDetailApi;
exports.qmCarOrderTestListApi = qmCarOrderTestListApi;
exports.qmExportExcelTaskApi = qmExportExcelTaskApi;
exports.qmExportExcelTaskListApi = qmExportExcelTaskListApi;
exports.qmExportReservationExcelTaskApi = qmExportReservationExcelTaskApi;
exports.qmExportTestExcelTaskApi = qmExportTestExcelTaskApi;
exports.qmOrderDetailApi = qmOrderDetailApi;
exports.qmOrgListApi = qmOrgListApi;
exports.qmStoreListApi = qmStoreListApi;
exports.qmSupplierListApi = qmSupplierListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @description  青民车俩核销 服务-- 列表
 */
function qmCarOrderListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/qm/car/order/verification/list',
    method: 'get',
    params: params
  });
}

/**
 * @description  青民车俩 安全检测-- 列表
 */
function qmCarOrderTestListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/qm/car/order/test/list',
    method: 'get',
    params: params
  });
}

/**
 * @description  青民车俩 订单预定-- 列表
 */
function qmCarOrderReservationListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/qm/car/order/reservation/list',
    method: 'get',
    params: params
  });
}
function qmOrgListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/qm/car/order/org/list',
    method: 'get',
    params: params
  });
}
function qmOrderDetailApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/qm/car/order/detail/' + params.id + "/" + params.date,
    method: 'get'
  });
}
function qmStoreListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/qm/car/order/store/list',
    method: 'get',
    params: params
  });
}
function qmSupplierListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/qm/car/order/supplier/list',
    method: 'get',
    params: params
  });
}
function qmExportExcelTaskApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/qm/car/order/export/asynchronous",
    method: 'post',
    data: data
  });
}
function qmExportTestExcelTaskApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/qm/car/order/export/test/asynchronous",
    method: 'post',
    data: data
  });
}
function qmExportReservationExcelTaskApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/qm/car/order/export/reservation/asynchronous",
    method: 'post',
    data: data
  });
}

/**
 * @description
 */
function qmExportExcelTaskListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/qm/car/order/export/asynchronous/list',
    method: 'get',
    params: params
  });
}
function qmCarOrderTestDetailApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/qm/car/order/test/detail",
    method: 'get',
    params: params
  });
}